import { SpaceSwitcher } from "../Spaces/Wrapper/SpaceSwitcher";

export const MobileHeader = ({ title, showBack }) => {
  return (
    <header className="mobile-header bg-body">
      <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
        <div className="d-flex align-items-center gap-2">
          {showBack && (
            <button
              className="header-btn"
              onClick={() => window.history.back()}
            >
              <i className="bi bi-chevron-left"></i>
            </button>
          )}
          <h1 className="h2 mb-0">{title}</h1>
        </div>
        <div className="space-switcher-dropdown-toggle">
          <SpaceSwitcher className="w-100" />
        </div>
      </div>
    </header>
  );
};
